var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.414,
    height: 22.414,
    viewBox: "0 0 22.414 22.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizza_disattivo",
    "data-name": "icona visualizza disattivo",
    transform: "translate(-0.793 -0.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_460",
    "data-name": "Tracciato 460",
    d: "M17.67,19.306A9.612,9.612,0,0,1,12,21.273c-6.682,0-10.5-7.636-10.5-7.636a17.611,17.611,0,0,1,4.83-5.67M10,6.229A8.705,8.705,0,0,1,12,6c6.682,0,10.5,7.636,10.5,7.636a17.659,17.659,0,0,1-2.062,3.045M14.024,15.66a2.864,2.864,0,1,1-4.047-4.047",
    transform: "translate(0 -1.636)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_461",
    "data-name": "Tracciato 461",
    d: "M1.5,1.5l21,21",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOff);
export default __webpack_public_path__ + "static/media/view_off.68ddabc6cd0f67ff8fab5ddf825c2544.svg";
export { ForwardRef as ReactComponent };